import React from 'react'

import { bemJoin } from 'bem-join'

import { useIntl } from '@app/intl/Intl'
import { InputField } from '@app/lib/fields/InputField/InputField'
import { Select } from '@app/lib/inputs/Select'

export const VatSelect = () => {
  const b = bemJoin('court-case-invoicing-form')
  const { formatMessage } = useIntl()

  const options = [
    {
      value: 0,
      label: '0%'
    },
    {
      value: 0.16,
      label: '16%'
    },
    {
      value: 0.19,
      label: '19%'
    }
  ]

  return (
    <InputField
      name='Vat'
      className={b('field', { md: true })}
      label={formatMessage({ id: 'CourtCases.Invoicing.Field.VAT' })}
      render={({ inputProps }) => {
        return <Select {...inputProps} triggerSize='sm' options={options} />
      }}
    />
  )
}
